import React, { useMemo, useState } from 'react'
import { getAdManagerConfig, isBrowser } from '../../config'
import { Gpt, GptConfig } from 'react-gpt-ads'

const ADScript = () => {
  const [loadScript, setLoadScript] = useState(false)
  const config = useMemo(() => {
    const locationPath = isBrowser() ? window.location.pathname : ''
    return getAdManagerConfig(locationPath)
  }, [])

  if (config?.find && config.id) {
    return (
      <div
        className={`h-[95px] hidden md:flex md:justify-center md:items-center relative w-full`}
        style={{ maxWidth: `${config.desktopSize[0]}px` }}
      >
        <Gpt
          adUnit={config.adUnit}
          name={`${config.id}-desktop`}
          size={config.desktopSize}
        />
        <GptConfig
          adUnit={config.adUnit}
          name={`${config.id}-desktop`}
          size={config.desktopSize}
          eventSlotRenderEnded={evt => {
            setLoadScript(true)
          }}
        />
        {!loadScript && (
          <div className="absolute top-0 bottom-0 left-0 right-0">
            <div className="w-full h-full skeleton-loader"></div>
          </div>
        )}
      </div>
    )
  }

  return null
}

export default ADScript
